/**
 * ACCORDION.JS
 * Initializes all accordions used on a page
 */

export default class Accordion {

	static initAll() {
		document.addEventListener('livewire:init', () => {
			Livewire.hook('morphed', () => {
				new Accordion();
			});
		});

		return new Accordion();
	}

	constructor() {
		const accordions = document.querySelectorAll('.accordion');

		if (accordions.length === 0)
			return;
	
		accordions.forEach((accordion) => {
			const accordionItems = accordion.querySelectorAll('.accordion-item');

			accordionItems.forEach((accordionItem) => {
				const accordionToggle = accordionItem.querySelector('.accordion-toggle');

				accordionToggle.addEventListener('change', () => {
					accordionItems.forEach((item) => {
						this.toggleAccordionItem(item, accordionItem === item && accordionToggle.checked);
					});
				});
			});
		});
	}

	/**
	 * Opens or closes passed accordion item
	 * @param {Element} accordionItem Accordion item container of a single accordion item ('.accordion-item')
	 * @param {Boolean} open Open/Close
	 */
	toggleAccordionItem(accordionItem, open) {
		let checkbox = accordionItem.querySelector('.accordion-toggle');
		let accordionContent = accordionItem.querySelector('.accordion-content');

		checkbox.checked = open;
		accordionContent.style.height = (open ? accordionContent.scrollHeight : 0) + 'px';

		setTimeout(() => {
			accordionContent.style.height = (open ? 'auto' : 0) + 'px';
		}, 300);
	}
}